import * as server from "@/utils/http"

export const _page = params => server.get("/send-inspect-log/page", params);

